export default "__VITE_ASSET__831fb88c__"